import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"; // Assuming Chakra UI for Tabs
import { useState } from "react";
import { Container } from "react-bootstrap";
import About from "./SampleTabs/About";
import IndianTeamDetails from "./SampleTabs/IndianTeamDetails";
import LogoMascot from "./SampleTabs/LogoMascot";
import MatchFixtures from "./SampleTabs/MatchFixtures";
import Results from "./SampleTabs/Results";
import Breadcrumb from "./common/Breadcrumb";

export default function GenericTabComponent({
  content = [
    {
      label: "About",
      component: <About />,
    },
    {
      label: "Logo and Mascot",
      component: <LogoMascot />,
    },
    {
      label: "Match Fixtures",
      component: <MatchFixtures />,
    },
    {
      label: "Indian Team Details",
      component: <IndianTeamDetails />,
    },
    {
      label: "Results",
      component: <Results />,
    },
  ],
  pageTitle="ISTAF Sepak Takraw 2025",
  desktopBanner="/img/istaf-sepak-takraw-2025-desktop.jpg",
  mobileBanner="/img/istaf-sepak-takraw-2025-mobile.jpg"
}) {
  const [selectedContentIndex, setSelectedContentIndex] = useState(0);

  return (
    <>
      <Breadcrumb
        pageName={GenericTabComponent}
        pageTitle={pageTitle}
        img_url={desktopBanner}
        mobile_banner={mobileBanner}
      />
      <Container style={{ marginTop: "30px", marginBottom: "30px" }}>
        <div
          className={`container`}
          style={{
            borderRadius: "8px",
            marginTop: "15px",
            marginBottom: "5px",
          }}
        >
          <Tabs
            isManual
            variant="enclosed"
            onChange={(index) => {
              setSelectedContentIndex(index);
            }}
          >
            {/* Menu Tabs */}
            <TabList
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "5px",
              }}
            >
              {content.map((v, i) => {
                return (
                  <>
                    <Tab
                      key={i}
                      className="tabb"
                      as="b"
                      style={{
                        backgroundColor:
                          selectedContentIndex === i
                            ? "rgb(49 62 69)"
                            : "#24528e", // Change background if active
                        color: "white",
                        padding: "5px 5px",
                        cursor: "pointer",
                        marginBottom: "20px",
                        fontSize: "12px",
                      }}
                    >
                      {v.label}
                    </Tab>
                  </>
                );
              })}
            </TabList>

            {/* Content Panels */}
            <TabPanels
              style={{
                borderLeft: "1px solid #cfd9de",
                borderRight: "1px solid #cfd9de",
                borderBottom: "1px solid #cfd9de",
                borderRadius: "0px 0px 5px 5px",
              }}
            >
              {content.map((v, i) => (
                <TabPanel key={i}>{v.component}</TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </div>
      </Container>
    </>
  );
}
